import { render } from "./enrolmentStep3_1.vue?vue&type=template&id=58dc73fe&scoped=true&slot=OneClass"
import script from "./enrolmentStep3_1.vue?vue&type=script&lang=js"
export * from "./enrolmentStep3_1.vue?vue&type=script&lang=js"

import "./enrolmentStep3_1.vue?vue&type=style&index=0&id=58dc73fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dc73fe"]])

export default __exports__